import { createFileRoute } from '@tanstack/react-router'
import AuditPlansPage from '@/pages/audit-plans/AuditPlansPage'

export const Route = createFileRoute('/audit-plans/')({
  component: AuditPlansPage,
})
